import { render } from "./AdminUploadImage.vue?vue&type=template&id=682a76f2"
import script from "./AdminUploadImage.vue?vue&type=script&lang=js"
export * from "./AdminUploadImage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__